import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";
export const TeamZoneManagementReducer = createSlice({
  name: "token",
  initialState: {
    editProject: null,
    priorityFilter: false,
    tabIndicatorValue: 0,
    calendarDepartmentId: JSON.parse(
      localStorage.getItem("hrmsCalendarDepartmentId")
    )
      ? JSON.parse(localStorage.getItem("hrmsCalendarDepartmentId"))
      : 99999,
    calendarDepartmentName: localStorage.getItem("hrmsCalendarDepartmentName")
      ? localStorage.getItem("hrmsCalendarDepartmentName")
      : "All",
    approveLeaveDepartmentName: localStorage.getItem(
      "approveLeaveDepartmentName"
    )
      ? localStorage.getItem("approveLeaveDepartmentName")
      : "All",
    approveLeaveDepartmentId: JSON.parse(
      localStorage.getItem("approveLeaveDepartmentId")
    )
      ? JSON.parse(localStorage.getItem("approveLeaveDepartmentId"))
      : 99999,
    editEmployeeId: JSON.parse(localStorage.getItem("editEmployeeIdNumber"))
      ? JSON.parse(localStorage.getItem("editEmployeeIdNumber"))
      : null,
    editEmployee: JSON.parse(localStorage.getItem("editEmployeeDetails"))
      ? JSON.parse(localStorage.getItem("editEmployeeDetails"))
      : null,
    employeeScreenAction: "",
    planShiftScreen: localStorage.getItem("planShiftScreen")
      ? localStorage.getItem("planShiftScreen")
      : "Daily",
    teamZoneSettingScreen: localStorage.getItem("settingScreens")
      ? localStorage.getItem("settingScreens")
      : "Leave Year",
    approveSettingsScreens: localStorage.getItem("approveSettingScreens")
      ? localStorage.getItem("approveSettingScreens")
      : "Leaves",
    showShiftBack: false,
    adminShiftLocation: "Shift",
    //Attendance Screen to attendance screen status passing arguments
    attendanceCompanyName: localStorage.getItem("attendanceCompanyName")
      ? localStorage.getItem("attendanceCompanyName")
      : "All Companies",
    attendanceCompanyId: JSON.parse(localStorage.getItem("attendanceCompanyId"))
      ? JSON.parse(localStorage.getItem("attendanceCompanyId"))
      : 99999,
    attendanceShiftName: localStorage.getItem("attendanceShiftName")
      ? localStorage.getItem("attendanceShiftName")
      : "All",
    attendanceShiftId: JSON.parse(localStorage.getItem("attendanceShiftId"))
      ? JSON.parse(localStorage.getItem("attendanceShiftId"))
      : 99999,
    attendanceDate: localStorage.getItem("attendanceDate")
      ? localStorage.getItem("attendanceDate")
      : moment(new Date()).format("YYYY-MM-DD"),
  },
  reducers: {
    setEditProject: (state, action) => {
      state.editProject = action.payload;
    },
    setPriorityFilter: (state, action) => {
      state.priorityFilter = action.payload;
    },
    setTabIndicatorValue: (state, action) => {
      state.tabIndicatorValue = action.payload;
    },
    setDepartmentId: (state, action) => {
      state.departmentId = action.payload;
    },
    setDepartmentLeadId: (state, action) => {
      state.departmentLeadId = action.payload;
    },
    setUpdateCalendarDepartmentId: (state, action) => {
      state.calendarDepartmentId = action.payload;
    },
    setUpdateCalendarDepartmentName: (state, action) => {
      state.calendarDepartmentName = action.payload;
    },
    setApproveLeaveDepartmentName: (state, action) => {
      state.approveLeaveDepartmentName = action.payload;
    },
    setApproveLeaveDepartmentId: (state, action) => {
      state.approveLeaveDepartmentId = action.payload;
    },
    setEditEmployee: (state, action) => {
      state.editEmployee = action.payload;
    },
    setEditEmployeeID: (state, action) => {
      state.editEmployeeId = action.payload;
    },
    setEmployeeScreenAction: (state, action) => {
      state.employeeScreenAction = action.payload;
    },
    setPlanShiftScreen: (state, action) => {
      state.planShiftScreen = action.payload;
    },
    setShowShiftBack: (state, action) => {
      state.showShiftBack = action.payload;
    },
    setAdminShiftLocation: (state, action) => {
      state.adminShiftLocation = action.payload;
    },
    //Attendance Screen to attendance screen status passing arguments
    setAttendanceCompanyName: (state, action) => {
      state.attendanceCompanyName = action.payload;
    },
    setAttendanceCompanyId: (state, action) => {
      state.attendanceCompanyId = action.payload;
    },
    setAttendanceShiftName: (state, action) => {
      state.attendanceShiftName = action.payload;
    },
    setAttendanceShiftId: (state, action) => {
      state.attendanceShiftId = action.payload;
    },
    setAttendanceDate: (state, action) => {
      state.attendanceDate = action.payload;
    },
  },
});

export const {
  setEditProject,
  setPriorityFilter,
  setTabIndicatorValue,
  setDepartmentId,
  setDepartmentLeadId,
  setUpdateCalendarDepartmentId,
  setUpdateCalendarDepartmentName,
  setApproveLeaveDepartmentName,
  setApproveLeaveDepartmentId,
  setEditEmployee,
  setEditEmployeeID,
  setEmployeeScreenAction,
  setPlanShiftScreen,
  setShowShiftBack,
  setAdminShiftLocation,
  setAttendanceCompanyName,
  setAttendanceCompanyId,
  setAttendanceShiftName,
  setAttendanceShiftId,
  setAttendanceDate,
} = TeamZoneManagementReducer.actions;

export default TeamZoneManagementReducer.reducer;
